import {Injectable} from '@angular/core';
import {ObjectService} from "./abstractions/objects/object.service.abstract";
import {Observable} from "rxjs";
import {
  IProductFeedOptions,
  IProductFeedSaveResponse
} from "../../models/product-feed-options.model";
import {ProductFeedTask} from '../../models/scheduled-task.model';

@Injectable({
  providedIn: 'root'
})
export class ProductFeedService extends ObjectService<IProductFeedOptions> {

  protected api = '/data-feeds/'; // Base URL for the client API

  replaceAsync(feed: IProductFeedOptions): Observable<IProductFeedSaveResponse> {
    return this.http.post<IProductFeedSaveResponse>(this.getEndpoint() + feed.id, feed);
  }

  deleteIfMatchAsync(id: string, etag: string): Observable<void> {
    return this.http.delete<void>(this.getEndpoint() + id, {
      headers: {'If-Match': etag}
    });
  }

  runProductFeedAsync(id: string): Observable<ProductFeedTask> {
    return this.http.post<ProductFeedTask>(this.getEndpoint() + id + '/run/2147483647', {});
  }

  getTaskAsync(id: string, taskId: string): Observable<ProductFeedTask> {
    return this.http.get<ProductFeedTask>(this.getEndpoint() + id + "/task/" + taskId);
  }

  getAllTasksAsync(id: string): Observable<ProductFeedTask[]> {
    return this.http.get<ProductFeedTask[]>(this.getEndpoint() + id + "/tasks");
  }

  getFieldMappingDefaultsAsync(): Observable<Record<string, Record<string, string>>> {
    return this.http.get<Record<string, Record<string, string>>>(this.getEndpoint() + 'field-mapping-defaults');
  }
}
